import { useState, useEffect } from "react";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { updateCart } from "../../actions";

export const useServiceHandler = (params) => {
  const [serviceData, setServiceData] = useState(null);
  const [quantityCounts, setQuantityCounts] = useState({});
  const [selectedDate, setSelectedDate] = useState({});
  const dispatch = useDispatch();
  const cartArr = useSelector((state) => state.cartArr);

  // Fetch single service detail
  const getSpecificService = async () => {
    const payload = {
      id: params.slug,
      type: params.category,
    };
    const response = await postApi(apiEndPoints.serviceDetails, payload);
    if (response && response.status === 200) {
      setServiceData(response?.data?.data);
    }
  };

  useEffect(() => {
    getSpecificService();
  }, [params]);

  // Increment quantity
  const increaseQuantity = (itemId) => {
    setQuantityCounts((prev) => ({
      ...prev,
      [itemId]: (prev[itemId] || 0) + 1,
    }));
  };

  // Decrement quantity
  const decreaseQuantity = (itemId) => {
    if (quantityCounts[itemId] > 1) {
      setQuantityCounts((prev) => ({
        ...prev,
        [itemId]: prev[itemId] - 1,
      }));
    }
  };

  // Add or update puja item in cart
    const handleOrderPuja = (item) => {
      if (!selectedDate[item._id]) {
        toast.error("Please select a date.");
        return;
      }
      const existingCartItem = cartArr.find(
        (cartItem) => cartItem._id === item._id
      );
      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          type: "Daily Service",
          type_id: 1,
          location: "",
          page: "services/daily",
          quantity: quantityCounts[item._id] || 1,
          selectedDate: selectedDate[item._id],
        };
        dispatch(updateCart(updatedItem));
      } else {
        const newItem = {
          ...item,
          type: "Daily Service",
          type_id: 1,
          location: "",
          page: "services/daily",
          quantity: quantityCounts[item._id] || 1,
          selectedDate: selectedDate[item._id],
        };
        dispatch(updateCart(newItem));
      }
    };

  return {
    serviceData,
    selectedDate,
    setSelectedDate,
    quantityCounts,
    increaseQuantity,
    decreaseQuantity,
    handleOrderPuja,
  };
};
